import ResourcePage from "@/components/ResourcePage";
import PageHeader from "@/components/PageHeader";

const fields = [
  { name: "name", label: "Nama Paket", required: true },
  { name: "price", label: "Harga", type: "number", required: true },
  { name: "description", label: "Deskripsi", type: "textarea", full: true },
  { name: "services", label: "Layanan Termasuk", type: "textarea", full: true },
  { name: "addons", label: "Add-ons", type: "textarea", full: true },
  { name: "terms", label: "Syarat & Ketentuan", type: "textarea", full: true },
];

const columns = [
  { key: "name", label: "Paket", render: (r) => <span className="font-semibold text-[#1A1A1A]">{r.name}</span> },
  { key: "price", label: "Harga", money: true },
  { key: "services", label: "Layanan", render: (r) => <span className="text-xs text-[#7A7A7A] line-clamp-1 max-w-xs block">{r.services}</span> },
];

export default function Packages() {
  return (
    <ResourcePage
      resource="packages" title="Paket" writeLevel={3}
      columns={columns} fields={fields}
      PageHeaderComp={<PageHeader overline="Paket Wedding" title="Packages" subtitle="Kelola paket dan harga layanan wedding Anda." />}
    />
  );
}
